import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Classes, OverlayToaster, Position, Spinner, } from '@blueprintjs/core';
import { createContext, useContext, useMemo, useRef } from 'react';
const ToasterContext = createContext(null);
export function useToaster() {
    const context = useContext(ToasterContext);
    if (!context) {
        throw new Error('Toaster context was not found');
    }
    return context;
}
export function ToasterProvider({ children }) {
    const toasterRef = useRef(null);
    const toaster = useMemo(() => {
        function show(options) {
            toasterRef.current?.show(options);
        }
        function showLoading(options) {
            const { message, ...otherProps } = options;
            const toastKey = toasterRef.current?.show({
                message: (_jsxs("div", { style: { display: 'flex', alignItems: 'center' }, children: [_jsx(Spinner, { size: 25 }), _jsx("span", { style: { marginLeft: '0.5em' }, children: message })] })),
                timeout: 0,
                ...otherProps,
            });
            return () => {
                if (toastKey) {
                    toasterRef.current?.dismiss(toastKey);
                }
            };
        }
        return { toaster: toasterRef.current, showLoading, show };
    }, []);
    return (_jsxs(_Fragment, { children: [_jsx(OverlayToaster, { className: Classes.DARK, position: Position.BOTTOM, ref: toasterRef }), _jsx(ToasterContext.Provider, { value: toaster, children: children })] }));
}
